export default {
  priority: 101,
  permissions: ["360EvaluationMenu/SettingMenu/"],
  name: app.translate('routes.home.evaluation-360.Settings'),
  icon: 'settings',
  drawer: true,
};
